// 轻量地址工具（无第三方依赖）
// 仅做基础规范化与校验，避免在 EVUS Step 4 频繁触发校验错误

export function normalizeLine(str) {
  if (!str) return '';
  const s = String(str).trim().replace(/\s+/g, ' ');
  return s.toUpperCase();
}

export function normalizeCity(str) {
  return normalizeLine(str);
}

export function isValidUSZip(zip) {
  if (!zip) return false;
  const z = String(zip).trim();
  return /^\d{5}(-\d{4})?$/.test(z);
}

